import React from "react";

import heroServicesImg from '../../../assets/images/heroServices.png';
import HeroSection from "../../common/HeroSection";
import { Container, Row, Col } from "reactstrap";
import { useNavigate } from "react-router-dom";

import provenResultsArcImg from '../../../assets/images/provenResultsArc.png';
import provenResultsArcImgMobile from '../../../assets/images/provenResultsArcMobile.png';
import problemsSolveArcImg from '../../../assets/images/problemsSolveArc.png';
import servicesArcImgMobile from '../../../assets/images/servicesArcMobile.png';

import { ReactComponent as CodeSvg } from '../../../assets/images/code.svg';

import './style.scss'; 
import ServicesBox from "../../common/ServicesBox";
import BaseBox from "../../common/BaseBox/BaseBox";
import BaseButton from "../../common/BaseButton";

export default function Services () {
    let navigate = useNavigate();

    return (
        <Container fluid className="services-page">
            <HeroSection
                title={'Customized IT Services for Every Business Need'}
                description={'Your Vision, Our Expertise – Scalable, Reliable, and Ready for Growth.'}
                icon={heroServicesImg}
                isTopArc
            />
            <Row className="services-section">
                <Col xs={12}>
                    <h2 className="heading-2">Our services</h2>
                </Col>
                <ServicesBox
                    title={"Outsourcing"}
                    description={"Extend your IT capacity with our dedicated specialists. From small projects to extensive rollouts, our outsourced team will work as an integral part of your organization, providing expertise and efficiency where you need it most."}
                />
                <ServicesBox
                    title={"Co-sourcing"}
                    description={"Enhance your in-house team with our skilled professionals. We work side-by-side with your existing staff, filling in gaps and providing expertise in UX/UI, front-end and back-end development, and quality assurance, ensuring your projects succeed without the strain of full-time hires."}
                />
                <ServicesBox
                    title={"Outstaffing"}
                    description={"Need an expert on your team temporarily? With our outstaffing service, you gain immediate access to top talent in design, development, and QA—without long-term commitments. Our team members integrate seamlessly, working under your management to achieve your business objectives."}
                />
                <Col xs={12}>
                    <img src={problemsSolveArcImg} className="services-arc" alt="problems arc"/>
                    <img src={servicesArcImgMobile} className="services-arc-mobile" alt="problems arc"/>
                </Col>
            </Row>
            <Row className="talents-section">
                <Col xs={12}>
                    <h2 className="heading-2">Specialized Talent</h2>
                </Col>
                <BaseBox
                    Icon={CodeSvg}
                    title={"UX/UI Designers"}
                    description={"Craft engaging, intuitive user experiences."}
                    colWidth={3}
                />
                <BaseBox
                    Icon={CodeSvg}
                    degreesShame={120}
                    title={"Front-End Developers"}
                    description={"Bring your vision to life with responsive, polished interfaces."}
                    colWidth={3}
                />
                <BaseBox
                    Icon={CodeSvg}
                    degreesShame={45}
                    title={"Back-End Developers"}
                    description={"Build secure, scalable, and efficient back-end systems."}
                    colWidth={3}
                />
                <BaseBox
                    degreesShame={260}
                    Icon={CodeSvg}
                    title={"QA Specialists"}
                    description={"Ensure flawless performance with meticulous testing and quality checks"}
                    colWidth={3}
                />
            </Row>
            <Row className="curious-services">
                <Col xs={12} md={5}>
                    <h2 className="heading-2">Curious about how we can fit into your team? Let’s discuss your needs!</h2>
                    <BaseButton onClick={() => navigate('/contacts')}/>
                    <img src={provenResultsArcImg} className="curious-arc" alt="curious arc"/>
                    <img src={provenResultsArcImgMobile} className="curious-arc-mobile" alt="curious arc mobile"/>
                </Col>
            </Row>
        </Container>
    )
}
